module.exports = __webpack_public_path__ + "img/news_page_info_article.53e73148.png";